<script setup>
import {ref} from 'vue'
import Text from './Forms/Text.vue'
import AddNewFields from "./Forms/AddNewFields.vue";

const props = defineProps({
  bank_account_name_differs: String,

  bank_account_name: String,
  bank_account_name_error: String,

  large: Boolean,
  compressed: Boolean,
})

const bankAccountNameError = ref(props.bank_account_name_error)

const bankAccountNameDiffers = ref(props.bank_account_name_differs)

</script>

<template>
  <div class="col-md-12 pt-4">
    <AddNewFields
        field="bank_account_name_differs"
        label="Der Kontoinhaber unterscheidet sich vom Auftraggeber"
        v-model:addNewFields="bankAccountNameDiffers"
    />
  </div>

  <div
      class="pt-4 col-12"
      v-if="bankAccountNameDiffers"
  >
    <Text
        field="bank_account_name"
        label="Kontoinhaber"
        :value="bank_account_name"
        :has-error="bankAccountNameError"
        :large="large"
    />
  </div>

</template>

<style scoped>

</style>